import { service } from '@ember/service';
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';

import type { Service } from 'webapp-types';

import ClientMetricsItemComponent from 'webapp/components/client/metrics/item';

import type { ClientMetric, Space } from 'webapp/models-custom';

interface Args {
	model: Space;
}

export default class ClientMetricsItemsComponent extends Component<Args> {
	@service('model-manager/client-metrics')
	declare mmClientMetricsService: Service.ModelManager.ClientMetrics;

	@cached
	get clientMetrics(): ClientMetric[] {
		const spaceId = this.spaceId;

		if (!spaceId) {
			return [];
		}

		return this.mmClientMetricsService.clientMetricsModels.filter(
			(item) => item.spaceId === spaceId,
		);
	}

	@cached
	get clientMetricsList(): ClientMetric[] {
		const clientMetrics = new Array<ClientMetric>(5);

		this.clientMetrics.forEach((metric) => {
			clientMetrics[metric.order] = metric;
		});

		return clientMetrics;
	}

	get spaceId(): number | null {
		return this.args.model.numericId;
	}
	<template>
		<ul>
			{{#each this.clientMetricsList as |metric index|}}
				<ClientMetricsItemComponent
					@model={{metric}}
					@position={{index}}
					@spaceId={{this.spaceId}}
				/>
			{{/each}}
		</ul>
	</template>
}
